export default __webpack_public_path__ + "static/media/immunology-and-oral-health.f6382c88.svg";